import { CaseSanctionType } from '@/@types/generated'
import { register } from './enum'

const CaseSanctionTypeLabels: Record<CaseSanctionType, string> = {
  [CaseSanctionType.NO_ACTION]: 'No Action',
  [CaseSanctionType.WARNING]: 'Warning',
  [CaseSanctionType.REVOCATION]: 'Revocation',
  [CaseSanctionType.SUSPENSION]: 'Suspension',
  [CaseSanctionType.RESTRICTIONS]: 'Restriction(s)',
  [CaseSanctionType.OTHER]: 'Other',
  [CaseSanctionType.ADMINISTRATIVE_PENALTY]: 'Administrative Penalty',
  [CaseSanctionType.PENALTY_AND_REVOCATION]: 'Penalty and Revocation',
}

register<CaseSanctionType>(CaseSanctionType, (v) => {
  if (!v) return '\u2014'
  return CaseSanctionTypeLabels[v]
})
